'use strict';

var angular = require('angular');
var dependencies = ['AVRO.ScheduleChange.ScheduleChangeData'];
module.exports = angular.module('AVRO.ScheduleChange.StepSignificantMarkets', dependencies).controller('StepSignificantMarketsController', require('./controllers/StepSignificantMarketsController')).directive('rmStepSignificantMarkets', require('./directives/StepSignificantMarketsDirective'));